import discountCardType from './discountCardType.json';
import discountMember from './discountMember.json';
import falsificat from './falsificat.json';
import discountCard from './discountCard.json';
import series from './series.json';
import legalEntity from './legalEntity.json';
import goods from './goods.json';
import goodsClassifier from './goodsClassifier.json';
import country from './country.json';
import labelDesignerTemplate from './labelDesignerTemplate.json';
import labelPrintScenario from './labelPrintScenario.json';
import accessPoint from './accessPoint.json';
import discountProgram from './discountProgram.json';
import producer from './producer.json';
import substance from './substance.json';
import tradeName from './tradeName.json';
import cureForms from './cureForms.json';
import legalEntities from './legalEntities.json';
import contractors from './contractors.json';
import stores from './stores.json';
import typeofStores from './typeofStores.json';
import gosContractFundingSource from './gosContractFundingSource.json';
import taxType from './taxType.json';
import supplierCodes from './supplierCodes.json';
import pricingModel from './pricingModel.json';
import barcode from './barcode.json';
import registerPrice from './registerPrice.json';
import pricing from './pricing.json';
import gosContract from './gosContract.json';
import exportDocumentTools from './exportDocumentTools.json';
import loyaltyProgram from './loyaltyProgram.json'
import disposal from "./disposal.json";
import marketing from './marketing.json'
import cheque from './cheque.json'
import storePlace from './storePlace.json'
import newsMaker from './newsMaker.json'
import companies from './companies.json'
import employees from "./employees.json";

export default {
  discountCardType,
  discountMember,
  falsificat,
  discountCard,
  series,
  legalEntity,
  goods,
  goodsClassifier,
  country,
  labelDesignerTemplate,
  labelPrintScenario,
  accessPoint,
  discountProgram,
  producer,
  substance,
  tradeName,
  cureForms,
  legalEntities,
  contractors,
  stores,
  typeofStores,
  gosContractFundingSource,
  taxType,
  supplierCodes,
  pricingModel,
  barcode,
  registerPrice,
  pricing,
  gosContract,
  exportDocumentTools,
  loyaltyProgram,
  disposal,
  marketing,
  storePlace,
  newsMaker,
  cheque,
  companies,
  marketing,
  employees
};